import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupIntersect3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBooleanGroupIntersect3"><Path d="M8.5 2.5H21.5V15.5H8.5V2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 8.5H15.5V12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 8.5H2.5V21.5H15.5V15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBooleanGroupIntersect3;
